import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AddCustomer.module.css';
import mockProfileImg from '../assets/images/mock_profile_img.png';
import { createCustomer } from '../services/customerService';

const AddCustomer = ({ onSave, onCancel }) => {
    const navigate = useNavigate();

    const [customerData, setCustomerData] = useState({
        name: '',
        email: '',
        phone_code: '+20',
        phone: '',
        gender: '',
        address: '',
        job: '',
        password: '',
        swag_id: '',
        nid: '',
        profile: null,
        nid_attachment: null
    });

    const [secondaryContacts, setSecondaryContacts] = useState([]);
    const [whatsappPhone, setWhatsappPhone] = useState('primary'); // Always primary, not changeable

    const [isFormValid, setIsFormValid] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [createdCustomer, setCreatedCustomer] = useState(null);

    const checkFormValidity = () => {
        const isValid = customerData.name.trim() !== '' &&
            // customerData.job.trim() !== '' &&
            customerData.phone.trim() !== '' &&
            // customerData.gender !== '' &&
            customerData.address.trim() !== '' &&
            customerData.password.trim() !== '' &&
            customerData.swag_id.trim() !== '';
        // customerData.nid.trim() !== '';

        setIsFormValid(isValid);
    };

    const handleFieldChange = (field, value) => {
        setCustomerData(prev => ({
            ...prev,
            [field]: value
        }));
        setError(''); // Clear error when user starts typing
    };

    const handlePhoneChange = (value) => {
        // Only allow numbers
        const numbersOnly = value.replace(/[^0-9]/g, '');

        if (numbersOnly.length > 0 && numbersOnly.charAt(0) === '0') {
            return;
        }

        setCustomerData(prev => ({
            ...prev,
            phone: numbersOnly
        }));
    };

    const handleSwagIdChange = (value) => {
        setCustomerData(prev => ({
            ...prev,
            swag_id: value
        }));
    };

    const addSecondaryContact = () => {
        setSecondaryContacts(prev => [
            ...prev,
            { phone_code: '+20', phone: '' }
        ]);
    };

    const removeSecondaryContact = (index) => {
        setSecondaryContacts(prev => prev.filter((_, i) => i !== index));
        // WhatsApp is always primary, so no need to handle WhatsApp phone changes
    };

    const updateSecondaryContact = (index, field, value) => {
        setSecondaryContacts(prev =>
            prev.map((contact, i) =>
                i === index ? { ...contact, [field]: value } : contact
            )
        );
    };

    // Remove handleWhatsappChange function since WhatsApp is fixed to primary

    // Check form validity whenever customerData changes
    useEffect(() => {
        checkFormValidity();
    }, [customerData]);

    const handleImageUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';

        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setCustomerData(prev => ({
                    ...prev,
                    profile: file
                }));
            }
        };

        fileInput.click();
    };

    const handlePdfUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.pdf,application/pdf';

        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setCustomerData(prev => ({
                    ...prev,
                    nid_attachment: file
                }));
            }
        };

        fileInput.click();
    };

    const handleSave = async () => {
        if (!isFormValid) return;

        setIsSubmitting(true);
        setError('');

        try {
            const formData = new FormData();
            formData.append('name', customerData.name);
            formData.append('email', customerData.email);
            formData.append('phone_code', customerData.phone_code);
            formData.append('phone', customerData.phone);
            // formData.append('gender', customerData.gender);
            formData.append('address', customerData.address);
            formData.append('job', customerData.job);
            formData.append('password', customerData.password);
            formData.append('swag_id', customerData.swag_id);
            formData.append('nid', customerData.nid);

            // Add WhatsApp phone flag - always primary
            // formData.append('whatsapp_phone', 'primary');

            // Add secondary contacts
            secondaryContacts.forEach((contact, index) => {
                formData.append(`secondary_contacts[${index}][phone_code]`, contact.phone_code);
                formData.append(`secondary_contacts[${index}][phone]`, contact.phone);
            });

            if (customerData.profile) {
                formData.append('profile', customerData.profile);
            }

            if (customerData.nid_attachment) {
                formData.append('nid_attachment', customerData.nid_attachment);
            }

            const result = await createCustomer(formData);
            setCreatedCustomer(result);
            setShowSuccessDialog(true);
        } catch (err) {
            setError(err.message || 'Failed to create customer');
        } finally {
            setIsSubmitting(false);
        }
    };

    // const handleGenderChange = (gender) => {
    //     setCustomerData(prev => ({
    //         ...prev,
    //         gender: gender
    //     }));
    // };

    const handleAssignUnit = () => {
        // Navigate to AddUnitToCustomer component with the customer ID and details
        console.log('createdCustomer:', createdCustomer); // Debug log
        console.log('createdCustomer structure:', JSON.stringify(createdCustomer, null, 2)); // More detailed debug log

        let customerData = null;
        let customerId = null;
        let customerName = null;
        let customerEmail = null;
        let customerSwagId = null;

        // Check different possible response structures
        if (createdCustomer) {
            // Try structure: createdCustomer.data (this is the correct one based on your API response)
            if (createdCustomer.data) {
                customerData = createdCustomer.data;
                customerId = customerData._id;
                customerName = customerData.name;
                customerEmail = customerData.email;
                customerSwagId = customerData.swag_id;
            }
            // Try structure: createdCustomer.code (but check if it's an object, not just a number)
            else if (createdCustomer.code && typeof createdCustomer.code === 'object') {
                customerData = createdCustomer.code;
                customerId = customerData._id;
                customerName = customerData.name;
                customerEmail = customerData.email;
                customerSwagId = customerData.swag_id;
            }
            // Try direct structure: createdCustomer
            else if (createdCustomer._id) {
                customerData = createdCustomer;
                customerId = customerData._id;
                customerName = customerData.name;
                customerEmail = customerData.email;
                customerSwagId = customerData.swag_id;
            }
            // Try structure: createdCustomer.customer
            else if (createdCustomer.customer) {
                customerData = createdCustomer.customer;
                customerId = customerData._id;
                customerName = customerData.name;
                customerEmail = customerData.email;
                customerSwagId = customerData.swag_id;
            }
        }

        console.log('Extracted data:', { customerId, customerName, customerEmail, customerSwagId }); // Debug log

        if (customerId && customerName) {
            console.log('Navigating to:', `/add-unit/${customerId}`); // Debug log

            // Navigate with customer information as URL parameters
            const searchParams = new URLSearchParams({
                customerName: customerName,
                customerEmail: customerEmail || '',
                customerSwagId: customerSwagId || ''
            });

            navigate(`/add-unit/${customerId}?${searchParams.toString()}`);
        } else {
            console.log('Customer data not found or invalid structure'); // Debug log
            console.log('Available properties in createdCustomer:', createdCustomer ? Object.keys(createdCustomer) : 'createdCustomer is null/undefined');

            // Show error to user
            setError('Unable to navigate to unit assignment. Customer data is incomplete.');
        }
    };

    const handleFinishLater = () => {
        setShowSuccessDialog(false);
        if (onSave && createdCustomer) {
            onSave(createdCustomer);
        }
    };

    const getProfilePreview = () => {
        if (customerData.profile) {
            return URL.createObjectURL(customerData.profile);
        }
        return mockProfileImg;
    };

    return (
        <div className={styles.addCustomerContainer}>
            {/* Header */}
            <div className={styles.headerContainer}>
                <div className={styles.headerLeft}>
                    <button className={styles.backButton} onClick={onCancel}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5" />
                            <path d="M12 19l-7-7 7-7" />
                        </svg>
                        Back
                    </button>
                    <h2 className={styles.headerTitle}>Add Customer</h2>
                </div>
                <div className={styles.headerActions}>
                    <button
                        className={`${styles.saveButton} ${!isFormValid || isSubmitting ? styles.disabled : ''}`}
                        onClick={handleSave}
                        disabled={!isFormValid || isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <svg className={styles.spinner} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 12a9 9 0 11-6.219-8.56" />
                                </svg>
                                Saving...
                            </>
                        ) : (
                            <>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 6L9 17l-5-5" />
                                </svg>
                                Save
                            </>
                        )}
                    </button>
                </div>
            </div>

            {/* Error Message */}
            {error && (
                <div className={styles.errorContainer}>
                    <span className={styles.errorText}>{error}</span>
                </div>
            )}

            {/* Content */}
            <div className={styles.contentContainer}>
                {/* Left Side - Form Fields */}
                <div className={styles.formSection}>
                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Name *</label>
                        <input
                            type="text"
                            value={customerData.name}
                            onChange={(e) => handleFieldChange('name', e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter customer name"
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Email</label>
                        <input
                            type="email"
                            value={customerData.email}
                            onChange={(e) => handleFieldChange('email', e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter customer email"
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Job</label>
                        <input
                            type="text"
                            value={customerData.job}
                            onChange={(e) => handleFieldChange('job', e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter job title"
                        />
                    </div>

                    {/* Primary Phone Section */}
                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Primary Phone (WhatsApp) *</label>
                        <div className={styles.phoneRow}>
                            <select
                                value={customerData.phone_code}
                                onChange={(e) => handleFieldChange('phone_code', e.target.value)}
                                className={styles.phoneCodeSelect}
                            >
                                <option value="+966">+966 (Saudi Arabia)</option>
                                <option value="+971">+971 (UAE)</option>
                                <option value="+965">+965 (Kuwait)</option>
                                <option value="+973">+973 (Bahrain)</option>
                                <option value="+968">+968 (Oman)</option>
                                <option value="+974">+974 (Qatar)</option>
                                <option value="+20">+20 (Egypt)</option>
                                <option value="+1">+1 (USA/Canada)</option>
                                <option value="+44">+44 (UK)</option>
                                <option value="+33">+33 (France)</option>
                                <option value="+49">+49 (Germany)</option>
                            </select>
                            <input
                                type="tel"
                                value={customerData.phone}
                                onChange={(e) => handlePhoneChange(e.target.value)}
                                className={styles.phoneInput}
                                placeholder="Enter phone number"
                            />
                            <div className={styles.whatsappIndicator}>
                                <span className={styles.whatsappIcon}>📱</span>
                                <span>WhatsApp</span>
                            </div>
                        </div>
                    </div>

                    {/* Secondary Phones Section */}
                    {secondaryContacts.map((contact, index) => (
                        <div key={index} className={styles.fieldGroup}>
                            <label className={styles.fieldLabel}>Secondary Phone {index + 1}</label>
                            <div className={styles.phoneRow}>
                                <select
                                    value={contact.phone_code}
                                    onChange={(e) => updateSecondaryContact(index, 'phone_code', e.target.value)}
                                    className={styles.phoneCodeSelect}
                                >
                                    <option value="+966">+966 (Saudi Arabia)</option>
                                    <option value="+971">+971 (UAE)</option>
                                    <option value="+965">+965 (Kuwait)</option>
                                    <option value="+973">+973 (Bahrain)</option>
                                    <option value="+968">+968 (Oman)</option>
                                    <option value="+974">+974 (Qatar)</option>
                                    <option value="+20">+20 (Egypt)</option>
                                    <option value="+1">+1 (USA/Canada)</option>
                                    <option value="+44">+44 (UK)</option>
                                    <option value="+33">+33 (France)</option>
                                    <option value="+49">+49 (Germany)</option>
                                </select>
                                <input
                                    type="tel"
                                    value={contact.phone}
                                    onChange={(e) => updateSecondaryContact(index, 'phone', e.target.value.replace(/[^0-9]/g, ''))}
                                    className={styles.phoneInput}
                                    placeholder="Enter phone number"
                                />
                                <button
                                    type="button"
                                    onClick={() => removeSecondaryContact(index)}
                                    className={styles.removePhoneButton}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))}

                    {/* Add Phone Button */}
                    <div className={styles.fieldGroup}>
                        <button
                            type="button"
                            onClick={addSecondaryContact}
                            className={styles.addPhoneButton}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                            Add Phone Number
                        </button>
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>National ID</label>
                        <input
                            type="text"
                            value={customerData.nid}
                            onChange={(e) => handleFieldChange('nid', e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter national ID number"
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>ID Attachment (PDF)</label>
                        <div className={styles.fileUploadContainer}>
                            <button
                                type="button"
                                onClick={handlePdfUpload}
                                className={styles.fileUploadButton}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17,8 12,3 7,8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                                {customerData.nid_attachment ? customerData.nid_attachment.name : 'Upload PDF'}
                            </button>
                            {customerData.nid_attachment && (
                                <span className={styles.fileInfo}>
                                    {(customerData.nid_attachment.size / 1024 / 1024).toFixed(2)} MB
                                </span>
                            )}
                        </div>
                    </div>

                    {/* <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Gender *</label>
                        <div className={styles.genderOptions}>
                            <label className={styles.genderOption}>
                                <input
                                    type="radio"
                                    name="gender"
                                    value="MALE"
                                    checked={customerData.gender === 'MALE'}
                                    onChange={() => handleGenderChange('MALE')}
                                    className={styles.genderRadio}
                                />
                                <span className={styles.genderCheckbox}>Male</span>
                            </label>
                            <label className={styles.genderOption}>
                                <input
                                    type="radio"
                                    name="gender"
                                    value="FEMALE"
                                    checked={customerData.gender === 'FEMALE'}
                                    onChange={() => handleGenderChange('FEMALE')}
                                    className={styles.genderRadio}
                                />
                                <span className={styles.genderCheckbox}>Female</span>
                            </label>
                        </div>
                    </div> */}

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Address *</label>
                        <textarea
                            value={customerData.address}
                            onChange={(e) => handleFieldChange('address', e.target.value)}
                            className={styles.fieldTextarea}
                            placeholder="Enter customer address"
                            rows="3"
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>Password *</label>
                        <input
                            type="password"
                            value={customerData.password}
                            onChange={(e) => handleFieldChange('password', e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter password"
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.fieldLabel}>SWAG ID *</label>
                        <input
                            type="text"
                            value={customerData.swag_id}
                            onChange={(e) => handleSwagIdChange(e.target.value)}
                            className={styles.fieldInput}
                            placeholder="Enter SWAG ID"
                        />
                    </div>
                </div>

                {/* Right Side - Image Upload */}
                <div className={styles.imageSection}>
                    <h3 className={styles.imageTitle}>Customer Profile Image</h3>
                    <div className={styles.imageUploadContainer}>
                        <div className={styles.imagePreview}>
                            <img src={getProfilePreview()} alt="Customer preview" />
                            <div className={styles.imageOverlay}>
                                <button
                                    className={styles.uploadButton}
                                    onClick={handleImageUpload}
                                    type="button"
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <polyline points="17,8 12,3 7,8" />
                                        <line x1="12" y1="3" x2="12" y2="15" />
                                    </svg>
                                    Upload Image
                                </button>
                            </div>
                        </div>
                        <p className={styles.imageHint}>
                            {customerData.profile ? customerData.profile.name : 'Click to upload customer profile image'}
                        </p>
                    </div>
                </div>
            </div>

            {/* Success Dialog */}
            {showSuccessDialog && (
                <div className={styles.dialogOverlay}>
                    <div className={styles.dialogContainer}>
                        <div className={styles.dialogHeader}>
                            <div className={styles.successIcon}>
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 6L9 17l-5-5" />
                                </svg>
                            </div>
                            <h3 className={styles.dialogTitle}>Customer Created Successfully!</h3>
                            <p className={styles.dialogMessage}>
                                {createdCustomer?.code?.name || 'Customer'} has been added to the system.
                            </p>
                        </div>
                        <div className={styles.dialogContent}>
                            <p className={styles.dialogQuestion}>Would you like to assign a unit to this customer now?</p>
                        </div>
                        <div className={styles.dialogActions}>
                            <button
                                className={styles.secondaryButton}
                                onClick={handleFinishLater}
                            >
                                Finish Later
                            </button>
                            <button
                                className={styles.primaryButton}
                                onClick={() => {
                                    console.log('Assign Unit button clicked'); // Debug log
                                    handleAssignUnit();
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                </svg>
                                Assign Unit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddCustomer; 